import styled from "styled-components";

export const AdvacedTabsGroupEditorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 96px;
`;

export const TabsGroupContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 600px;
`;

export const TabsGroupPlaceholder = styled.div`
  display: flex;
  justify-content: ${({ alignment }) => alignment};
  color: ${({ theme }) => theme.text.text};
`;

export const DesignContainer = styled.div`
  display: flex;
  justify-content: ${({ alignment }) => alignment};
`;
